import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import React from 'react'
import { ForEachModel, Model, ValueToCollection } from '@morningtrain/react-resources'
import HistoricalChecklistSummary from 'pages/app/checklists/HistoricalChecklistSummary'
import { SelectedDepartmentFilter } from 'support/filters'
import ChecklistStreakTitle from 'pages/app/checklists/ChecklistStreakTitle'
import * as UI from 'ui'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'

export function ChecklistSmartview () {
  return (
    <Translator namespace='smartviews.checklists'>
      <Model resourceName='checklists.checklists' operationName='historical'>
        <Smartview header={<ChecklistStreakTitle />}>
          <UI.SecondaryHeading>
            <Translation name='checklists.historic.title' />
          </UI.SecondaryHeading>
          <SmartviewContentSeparator className='my-3' />
          <SelectedDepartmentFilter />
          <ValueToCollection name='collection'>
            <SmartviewTextGroup highlight>
              <ForEachModel>
                <HistoricalChecklistSummary />
              </ForEachModel>
            </SmartviewTextGroup>
          </ValueToCollection>
        </Smartview>
      </Model>
    </Translator>
  )
}
